export const oneMoreThing = {
  teaser: 'Every project starts with a single question.',
  reveal: 'What should people feel when they meet you?',
  /** Big headline under Pixel — one entry per line */
  heading: ['Let’s make it', 'unforgettable'],
  /** Serif line under the headline, leading into the work showcase */
  outro: 'Great brands aren’t seen. They’re felt.',
};
